import { IApplySubQueryPlaceholders } from '@kurtosys/types/utils/IApplySubQueryPlaceholders.js';

import { commonUtils } from '../../common/index.js';

export function applySubQueryPlaceholders(params: IApplySubQueryPlaceholders): any {
	let { template } = params;
	const { executionOptions, subQueries, allSubQueryValuesRequired, translationHelper, dependencies } = params;

	// apply translations before applying query placeholder values - as we wont have translations for every permutation of the template with values.
	if (translationHelper && translationHelper.translate) {
		template = translationHelper.translate(template);
	}

	if (subQueries) {
		const subQueryValues: { [key: string]: any } = {};
		let hasBlankValue = false;
		for (const subQueryIndex in subQueries) {
			const subQueryOptions = subQueries[subQueryIndex];
			const { queryId = `subQuery${subQueryIndex}` } = subQueryOptions;
			const subQuery = new dependencies.queryClass(subQueryOptions, translationHelper);
			const subQueryValue = subQuery.execute(executionOptions);
			const key = `sub:${queryId}`;
			if (allSubQueryValuesRequired && commonUtils.isNullOrEmpty(subQueryValue)) {
				hasBlankValue = true;
				break;
			}
			subQueryValues[key] = subQueryValue;
		}
		if (allSubQueryValuesRequired && hasBlankValue) {
			template = undefined;
		} else {
			template = commonUtils.replacePlaceholders({ values: subQueryValues, text: template });
		}
	}
	return template;
}
